import { useMemo } from 'react';
import type { OtpChannelContentProps, OtpChannelProps } from './otp-channel.types';
import { getColorVar } from '../../../theme/color-utils';
import { cn } from '../../utils/cn';

import styles from './otp-channel.module.css';

export const useOtpChannelView = ({
    channel,
    textProps,
    primaryIconProps,
    containerClassName,
}: Pick<OtpChannelProps, 'channel' | 'textProps' | 'primaryIconProps' | 'containerClassName'>) => {
    const otpChannelIconUri = useMemo(() => {
        if (channel?.icon) {
            return channel?.icon;
        }
        return channel?.name === 'SMS' ? '/assets/icons/sms.svg' : '/assets/icons/zalo.svg';
    }, [channel?.icon, channel?.name]);

    const otpChannelIconProps: OtpChannelContentProps['leadingIconProps'] = useMemo(() => {
        return {
            type: 'data-uri',
            dataUriProps: {
                src: otpChannelIconUri,
                alt: `Phương thức nhận mã OTP ${channel?.name}`,
            },
            className: styles.primaryIcon,
            ...primaryIconProps,
        };
    }, [channel?.name, otpChannelIconUri, primaryIconProps]);

    const rightIconProps: OtpChannelContentProps['trailingIconProps'] = useMemo(() => {
        return {
            name: 'chevron-right',
            color: getColorVar('slate', '20'),
        };
    }, []);

    const labelProps: OtpChannelContentProps['labelProps'] = useMemo(() => {
        return {
            ...textProps,
            className: cn(styles.primaryText, textProps?.className),
        };
    }, [textProps]);

    const containerStyles = useMemo(() => {
        return cn(containerClassName, styles.container);
    }, [containerClassName]);

    return {
        otpChannelIconProps,
        rightIconProps,
        labelProps,
        containerStyles,
    };
};
